import { Action } from '@ngrx/store';
import { SummaryFinancialIncomeListModel, SummaryFinancialIncomeModel } from '../../models/summary-financial-income.model';

import { SingleResponseModel } from '../../../../common/models/single-response.model';

export enum FinancialIncomeActionTypes {
  LoadFinancialIncomes = '[FinancialIncomes] Load Financial Incomes',
  LoadFinancialIncomesSuccess = '[FinancialIncomes] Load Financial Incomes Success',
  LoadFinancialIncomesFailure = '[FinancialIncomes] Load Financial Incomes Failure',

  LoadFinancialIncome = '[FinancialIncome] Load Financial Income',
  LoadFinancialIncomeSuccess = '[FinancialIncome] Load Financial Income Success',
  LoadFinancialIncomeFailure = '[FinancialIncome] Load Financial Income Failure',

  CreateFinancialIncome = '[FinancialIncome] Create Financial Income',
  CreateFinancialIncomeSuccess = '[FinancialIncome] Create Financial Income Success',
  CreateFinancialIncomeFailure = '[FinancialIncome] Create Financial Income Failure',

  UpdateFinancialIncome = '[FinancialIncome] Update Financial Income',
  UpdateFinancialIncomeSuccess = '[FinancialIncome] Update Financial Income Success',
  UpdateFinancialIncomeFailure = '[FinancialIncome] Update Financial Income Failure',

  DeleteFinancialIncome = '[FinancialIncome] Delete Financial Income',
  DeleteFinancialIncomeSuccess = '[FinancialIncome] Delete Financial Income Success',
  DeleteFinancialIncomeFailure = '[FinancialIncome] Delete Financial Income Failure',
}

/** Load all */

export class LoadFinancialIncomes implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncomes;
  constructor(public payload: { filter: any }) { }
}

export class LoadFinancialIncomesSuccess implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncomesSuccess;
  constructor(public payload: {
    items: SummaryFinancialIncomeModel[];
    total: number;
    summary: SummaryFinancialIncomeListModel;
  }) { }
}

export class LoadFinancialIncomesFailure implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncomesFailure;
  constructor(public payload: { error: any }) { }
}

/** Load by id */

export class LoadFinancialIncome implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncome;
  constructor(public payload: { uid: string }) { }
}

export class LoadFinancialIncomeSuccess implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncomeSuccess;
  constructor(public payload: SingleResponseModel<SummaryFinancialIncomeModel>) { }
}

export class LoadFinancialIncomeFailure implements Action {
  readonly type = FinancialIncomeActionTypes.LoadFinancialIncomeFailure;
  constructor(public payload: { error: any }) { }
}

/** Create */

export class CreateFinancialIncome implements Action {
  readonly type = FinancialIncomeActionTypes.CreateFinancialIncome;
  constructor(public payload: { financialIncome: SummaryFinancialIncomeModel }) { }
}


export class CreateFinancialIncomeSuccess implements Action {
  readonly type = FinancialIncomeActionTypes.CreateFinancialIncomeSuccess;
  constructor(public payload: { financialIncome: SummaryFinancialIncomeModel }) { }
}

export class CreateFinancialIncomeFailure implements Action {
  readonly type = FinancialIncomeActionTypes.CreateFinancialIncomeFailure;
  constructor(public payload: { error: any }) { }
}


/** Update */

export class UpdateFinancialIncome implements Action {
  readonly type = FinancialIncomeActionTypes.UpdateFinancialIncome;
  constructor(public payload: { financialIncome: SummaryFinancialIncomeModel }) { }
}

export class UpdateFinancialIncomeSuccess implements Action {
  readonly type = FinancialIncomeActionTypes.UpdateFinancialIncomeSuccess;
  constructor(public payload: { financialIncome: SummaryFinancialIncomeModel }) { }
}

export class UpdateFinancialIncomeFailure implements Action {
  readonly type = FinancialIncomeActionTypes.UpdateFinancialIncomeFailure;
  constructor(public payload: { error: any }) { }
}


/** Delete */

export class DeleteFinancialIncome implements Action {
  readonly type = FinancialIncomeActionTypes.DeleteFinancialIncome;
  constructor(public payload: { uid: string }) { }
}

export class DeleteFinancialIncomeSuccess implements Action {
  readonly type = FinancialIncomeActionTypes.DeleteFinancialIncomeSuccess;
  constructor(public payload: { uid: string }) { }
}

export class DeleteFinancialIncomeFailure implements Action {
  readonly type = FinancialIncomeActionTypes.DeleteFinancialIncomeFailure;
  constructor(public payload: { error: any }) { }
}

export type FinancialIncomeActions =
  | LoadFinancialIncomes
  | LoadFinancialIncomesSuccess
  | LoadFinancialIncomesFailure
  | LoadFinancialIncome
  | LoadFinancialIncomeSuccess
  | LoadFinancialIncomeFailure
  | CreateFinancialIncome
  | CreateFinancialIncomeSuccess
  | CreateFinancialIncomeFailure
  | UpdateFinancialIncome
  | UpdateFinancialIncomeSuccess
  | UpdateFinancialIncomeFailure
  | DeleteFinancialIncome
  | DeleteFinancialIncomeSuccess
  | DeleteFinancialIncomeFailure
